import { FC, ReactNode } from "react";
import styled from "styled-components";

interface IProps {
  children: {
    sidebar: ReactNode;
    taskManager: ReactNode;
    content: ReactNode;
    performanceDashboard: ReactNode;
    isDashboardPanelOpen: boolean;
    isTaskListCollapsed: boolean;
    isTaskManagerOpen: boolean;
  };
}

const RootContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.theme.neutral};
`;

const SideContainer = styled.div<{ isTaskListCollapsed: boolean }>`
  min-width: ${(props) => (props.isTaskListCollapsed ? "4rem" : "15rem")};
  width: ${(props) => (props.isTaskListCollapsed ? "4rem" : "15%")};
  max-width: 18rem;
  flex-shrink: 0;
  position: relative;
  z-index: 99999999;
  transition: all 0.3s ease-out;
`;

const TaskListContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const TaskManagerContainer = styled.div<{ isTaskManagerOpen: boolean }>`
  width: 100%;
  height: 100%;
  min-width: 15rem;
  right: 0;
  transform: ${(props) =>
    props.isTaskManagerOpen ? `translateX(100%)` : "none"};
  position: absolute;
  visibility: ${(props) => (props.isTaskManagerOpen ? "visible" : "hidden")};
  display: block;
  transition: all 0.2s ease-out;
`;

const ContentContainer = styled.main<{
  isTaskListCollapsed: boolean;
}>`
  width: 100%;
  padding: 1.25rem;
  transition: all 0.3s ease-out;
`;

const PerformanceDashboardContainer = styled.div<{
  isDashboardPanelOpen: boolean;
}>`
  min-width: ${(props) => (props.isDashboardPanelOpen ? "15rem" : "1.5rem")};
  width: ${(props) => (props.isDashboardPanelOpen ? "15%" : "1.5rem")};
  max-height: 100%;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  flex-shrink: 0;
  transition: all 0.3s ease-out;
`;

const MainLayout: FC<IProps> = ({ children }) => {
  const {
    sidebar,
    taskManager,
    content,
    performanceDashboard,
    isDashboardPanelOpen,
    isTaskListCollapsed,
    isTaskManagerOpen,
  } = children;

  return (
    <RootContainer>
      <SideContainer isTaskListCollapsed={isTaskListCollapsed}>
        <TaskManagerContainer isTaskManagerOpen={isTaskManagerOpen}>
          {taskManager}
        </TaskManagerContainer>
        <TaskListContainer>{sidebar}</TaskListContainer>
      </SideContainer>
      <ContentContainer
        isTaskListCollapsed={isTaskListCollapsed}
      >
        {content}
      </ContentContainer>
      <PerformanceDashboardContainer
        isDashboardPanelOpen={isDashboardPanelOpen}
      >
        {performanceDashboard}
      </PerformanceDashboardContainer>
    </RootContainer>
  );
};

export default MainLayout;
